/* eslint-disable react/prop-types */

import { type Carer, UserRole } from '@lmc/ts-common'
import type { TabBarItem } from 'components/generic/TabBar/TabBar'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { TabBar } from '../../../components/generic'
import { withRouter } from '../../../withRouter'
import { RotaPaywallScreen } from './RotaPaywallScreen'

type NavItem = {
  url: string
  label: string
}

const RotaRouteScreen: FC<{ location: any; router: any }> = ({
  location,
  router
}) => {
  const flags = useFeatureFlags({
    flagNames: ['published_rota', 'payrates']
  })?.data
  const userRole = useSelector(
    (state: { global: { user: Carer } }) => state.global.user?.role
  )

  const { hasRota } = useHomeType()

  const flagsPublishedRotaEnabled = flags?.published_rota?.enabled
  const payratesEnabled = flags?.payrates?.enabled
  const isAdmin = userRole === UserRole.careHomeAdmin
  const isReconciliationPath = router.location.pathname.startsWith(
    '/rota/reconciliation'
  )

  let items: NavItem[] = []

  if (!hasRota) {
    items = []
  } else {
    const baseTabs = flagsPublishedRotaEnabled
      ? NAV_TABS_WITH_PUBLISHED
      : NAV_TABS_WITH_MONITORING

    items =
      payratesEnabled && isAdmin
        ? [...baseTabs, { url: 'reconciliation', label: 'Reconciliation' }]
        : baseTabs
  }

  return (
    <div>
      {!isAdmin && isReconciliationPath && (
        <Navigate to="/rota/builder" replace />
      )}
      <TabBar
        // @ts-ignore
        items={items}
        resourceUrl="rota"
        location={location}
      />
      <Outlet />
      {hasRota ? (
        router.location.pathname === '/rota' && <Navigate to="builder" />
      ) : (
        <RotaPaywallScreen />
      )}
    </div>
  )
}

export default withRouter(RotaRouteScreen)

const getSearchWithoutTabKey = () => {
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.delete('tabKey')
  const nextSearch = searchParams.toString()

  return nextSearch ? `?${nextSearch}` : ''
}

const NAV_TABS_WITH_MONITORING = [
  {
    url: 'monitoring',
    label: 'Monitoring'
  },
  {
    url: 'builder',
    label: 'Rota Builder'
  },
  {
    url: 'patterns',
    label: 'Manage Patterns'
  }
]

const NAV_TABS_WITH_PUBLISHED: TabBarItem[] = [
  {
    url: 'published',
    label: 'Published',
    search: getSearchWithoutTabKey
  },
  {
    url: 'monitoring',
    label: 'Monitoring'
  },
  {
    url: 'builder',
    label: 'Builder',
    search: getSearchWithoutTabKey
  },
  {
    url: 'patterns',
    label: 'Manage Patterns'
  }
]
